/**
 * The type of (redux) action which signals that session status polling should start.
 *
 * {
 *     type: SESSION_POLLING_STARTED,
 *     sessionId: string,
 *     pollInterval: number
 * }
 */
export const SESSION_POLLING_STARTED = 'SESSION_POLLING_STARTED';
/**
 * The type of (redux) action which signals that session status polling should stop.
 *
 * {
 *     type: SESSION_POLLING_STOPPED
 * }
 */
export const SESSION_POLLING_STOPPED = 'SESSION_POLLING_STOPPED';
/**
 * The type of (redux) action which signals that the session status has been updated.
 *
 * {
 *     type: SESSION_STATUS_UPDATED,
 *     sessionId: string,
 *     status: string
 * }
 */
export const SESSION_STATUS_UPDATED = 'SESSION_STATUS_UPDATED';
/**
 * The type of (redux) action which signals that the session has been ended by therapist.
 *
 * {
 *     type: SESSION_ENDED_BY_THERAPIST,
 *     sessionId: string
 * }
 */
export const SESSION_ENDED_BY_THERAPIST = 'SESSION_ENDED_BY_THERAPIST';
/**
 * The type of (redux) action which signals that session status check failed.
 *
 * {
 *     type: SESSION_STATUS_CHECK_FAILED,
 *     error: Error
 * }
 */
export const SESSION_STATUS_CHECK_FAILED = 'SESSION_STATUS_CHECK_FAILED';
